import { UniformStatsSection } from "./stats-section.tsx";

export default UniformStatsSection;
